<div mdbModal role="dialog" min-width="95%" >
  <div class="modal-body" [style.--audit-modal-max-height.px]="auditModalMaxHeight">
    <div class="container-fluid">
          <div class="audit-grid-wrap">
    <section *ngIf="clientChangeLogList.length > 0" class="changelog-section">
      <!-- ── Visible / paginated table ── -->
      <div class="table-panel">
        <lms-table-wrapper [config]="config">
          <table class="changelog-table table-auto ">
            <caption class="table-caption">Client Change Log</caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Date / Time</th>
                <th scope="col">Branch</th>
                <th scope="col">Changed by</th>
                <th scope="col">Change type</th>
                <th scope="col">ID number</th>
                <th scope="col" class="col-data">Previous data</th>
                <th scope="col" class="col-data col-data--new">New data</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of clientChangeLogList | paginate: config" class="changelog-row">
                <td data-label="Date / Time"   class="col-date">{{ log?.date | date: 'yyyy/MM/dd' }}</td>
                <td data-label="Branch"        >{{ log.branchName }}</td>
                <td data-label="Changed by"    >{{ log?.changeBy }}</td>
                <td data-label="Change type"   >
                  <span class="change-badge">{{ log.changeType }}</span>
                </td>
                <td data-label="ID number"     class="col-id">{{ log.idNumber }}</td>
                <td data-label="Previous data" class="col-data col-data--prev">{{ log.previousData }}</td>
                <td data-label="New data"      class="col-data col-data--new">{{ log.newData }}</td>
              </tr>
            </tbody>
          </table>
        </lms-table-wrapper>
      </div>

      <!-- ── Hidden full table for Excel export ── -->
      <div class="export-table-wrapper" #TABLE>
        <table #table hidden="true">
          <caption>Client Change Log Results</caption>
          <thead>
            <tr>
              <th scope="col">Date/Time</th>
              <th scope="col">Branch Name</th>
              <th scope="col">Change by</th>
              <th scope="col">Change Type</th>
              <th scope="col">Id Number</th>
              <th scope="col">Previous Data</th>
              <th scope="col">New Data</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of clientChangeLogList">
              <td>{{ log?.date }}</td>
              <td>{{ log.branchName }}</td>
              <td>{{ log?.changeBy }}</td>
              <td>{{ log.changeType }}</td>
              <td>{{ log.idNumber }}</td>
              <td>{{ log.previousData }}</td>
              <td>{{ log.newData }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>
  </div>

  <div modal-actions class="action-bar">
    <button class="btn-action btn-export" (click)="exportLogsToExcel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export to Excel
    </button>
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</div>
